import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';

// Models
import {
  DropdownActionTypes,
  PaginatedOrgsPayload,
  PaginatedOrgsResponse,
} from 'app/shared/dropdown/models';
import { PaginatedAgentsPayload } from 'app/modules/agents/requests';
import { PaginatedAgentsResponse } from 'app/modules/agents/responses';

export const retrieveDropdownAgents = (payload: PaginatedAgentsPayload) => {
  return createAction(DropdownActionTypes.RETRIEVE_DROPDOWN_AGENTS, payload);
};

export const retrieveDropdownAgentsSuccess = (
  result: PaginatedAgentsResponse,
) => {
  return createAction(
    DropdownActionTypes.RETRIEVE_DROPDOWN_AGENTS_SUCCESS,
    result,
  );
};

export const retrieveDropdownOrgs = (payload: PaginatedOrgsPayload) => {
  return createAction(DropdownActionTypes.RETRIEVE_DROPDOWN_ORGS, payload);
};

export const retrieveDropdownOrgsSuccess = (result: PaginatedOrgsResponse) => {
  return createAction(
    DropdownActionTypes.RETRIEVE_DROPDOWN_ORGS_SUCCESS,
    result,
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ReduxActionsList = {
  retrieveDropdownAgents,
  retrieveDropdownAgentsSuccess,
  retrieveDropdownOrgsSuccess,
};

type ReduxActions = ActionsUnion<typeof ReduxActionsList>;
export default ReduxActions;
